/* istanbul ignore file */
import { getIn } from 'seamless-immutable';

const getDeadlineWeekDay = deadline => {
  const weekDays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  const date = new Date();
  const today = date.getDay();
  const day = today + deadline;

  return weekDays[day % 7];
};

const fmtBusinessHoursText = businessHours => {
  const { start, end } = businessHours;

  if (start && end) {
    return `${start.split(':')[0]}h às ${end.split(':')[0]}h`;
  }

  return undefined;
};

export const fmtStores = (stores, selectedStore) => {
  const secondStoreDistance = getIn(stores, [1, 'distance'], Infinity);

  return stores.map((store, index) => {
    const {
      sellerStoreId,
      distance,
      name,
      schedules,
      deliveryDaysPNLH: pnlh,
      deliveryDaysSFS: sfs,
      address: location,
    } = store;
    const { address, number, neighborhood, city, state } = location;
    const deadlineWeekDay = getDeadlineWeekDay(pnlh);
    const businessHours = schedules[deadlineWeekDay];
    const businessHoursText = fmtBusinessHoursText(businessHours);
    const fullAddress = `${address}, ${number} - ${neighborhood} - ${city}/${state}`;
    const shipFromStore = sfs !== null && sfs >= 0 ? sfs : undefined;
    const pickupStore = pnlh !== null && pnlh >= 0 ? pnlh : undefined;
    const selected = sellerStoreId === getIn(selectedStore, ['sellerStoreId']);
    const distanceWarning = index === 0 && distance > secondStoreDistance;

    return {
      name,
      distanceWarning,
      businessHoursText,
      fullAddress,
      distance,
      shipFromStore,
      pickupStore,
      selected,
      id: sellerStoreId,
      selectedStore,
      raw: store,
    };
  });
};
